export default "__VITE_ASSET__qPF9Tb8L__"